import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppPtiRanking } from '../models/mobileAppPtiRanking';

const RISK_LABEL_HIGH = 'High';

@Component({
  template: `
    <div style="display:flex; column-gap: 4px;">
      <img
        style="width: 20px;"
        src="/assets/images/high-risk-icon.png"
        alt="High Risk Icon"
      />
      <span
        style="text-transform: capitalize; color: rgba(0, 0, 0, 0.70);
                  text-align: center;
                  font-family: Inter;
                  font-size: 14.458px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 120%; 
                  text-transform: capitalize;"
      >
        {{ riskLabel }}
      </span>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RatingSignalComponent
  extends DataWidgetComponent
  implements OnInit
{
  @Input()
  data: MobileAppPtiRanking;

  risk: string;

  ngOnInit(): void {
    super.ngOnInit();

    this.risk = this.data[this.key];
  }

  get riskLabel(): string {
    return RISK_LABEL_HIGH;
  }
}
